import { render, staticRenderFns } from "./OperaGoodsDetailWindow.vue?vue&type=template&id=1969f9af&scoped=true&"
import script from "./OperaGoodsDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsDetailWindow.vue?vue&type=style&index=0&id=1969f9af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969f9af",
  null
  
)

export default component.exports